// extracted by mini-css-extract-plugin
export default {"h":"styles_h__LZODW","p":"styles_p__ZxIwy","box":"styles_box__duzf7","image":"styles_image__ld20Q"};